import React from 'react';
import { useTranslation } from 'react-i18next';
import { prettyNumber } from '../../../../utils/helpers';
import {
  PriceSectionContainer,
  SectionArea,
  SectionPrice,
  SectionPricePerUnit
} from './styled';
import { checkIsAreaCategory } from '../../../../utils/helpers/common';
import { PlaceholderBlock } from '../../../../styled/placeholders.styled';

interface PriceSectionProps {
  categoryId?: string;
  priceTotal?: number | null;
  pricePerAre?: number | null;
  area?: number | null;
  priceCurrency: string;
  areaCurrency?: string | null;
  isApartmentForSale?: boolean;
  isAuthor: boolean;
  userRelatedItemLoading: boolean;
}

export const PriceSection: React.FC<PriceSectionProps> = ({
  categoryId,
  priceTotal,
  pricePerAre,
  area,
  priceCurrency,
  areaCurrency,
  isApartmentForSale,
  isAuthor,
  userRelatedItemLoading
}) => {
  const { t } = useTranslation();

  const prettyPrice = prettyNumber(priceTotal);
  const pricePerSqm = (
    Math.round((priceTotal || 0) / (area || 0) / 10) * 10
  ).toFixed();
  const prettyPricePerSqm = prettyNumber(pricePerSqm);
  const prettyPricePerAre = prettyNumber(pricePerAre);

  return (
    <PriceSectionContainer data-cy="price-section">
      <SectionPrice
        tag="h2_new"
        data-cy="price-section__i"
        $withBigMargin={isApartmentForSale}
        $withMargin={isApartmentForSale}
      >
        {prettyPrice} {priceCurrency}
      </SectionPrice>
      {checkIsAreaCategory(categoryId) && pricePerAre != null && (
        <SectionPricePerUnit tag="body_3" data-cy="price-section__per_unit">
          {t('pages.current_item.price_per_acre', {
            price: prettyPricePerAre,
            currency: priceCurrency,
            area_currency: areaCurrency
          })}
        </SectionPricePerUnit>
      )}
      {isApartmentForSale && (
        <SectionArea tag="body_3" data-cy="price-section__i">
          {t('pages.current_item.price_per_sqm', {
            price: prettyPricePerSqm,
            area_currency: areaCurrency
          })}
        </SectionArea>
      )}
      {userRelatedItemLoading && (
        <PlaceholderBlock height="48px" margin="0" borderRadius="14px" />
      )}
    </PriceSectionContainer>
  );
};
